﻿import { CompatiblePairKpdReasons } from "@nkr/enums/compatible-pair-kpd-reasons";

﻿export interface IFavorableBloodTypeCompatiblePair {
    recipientCenter: string;
    recipientId: number;
    recipientAlias: string;
    recipientBloodType: string;
    oTiterString: string;
    donorBloodType: string;
    firstDonorBloodType: string;
    maxDonorAge: number;
    minHLAMatch: number;
    cPRA4: number;
    recipientStatusId: number;
    recipientStatus: string;
    chainId: number;
    compatiblePairStartDate: string;
    compatiblePairEndDate: string;
    clCu: number;
    rAge: number;
    dAge: string;
    rmPa: number;
    rmPb: number;
    rmPc: number;
    dmp: string;
    pmPa: number;
    pmPb: number;
    pmPc: number;
    erosion: number;
    dialysis: string;
    ewt: string;
    wait: number;
    exportableDaysInNkr: number;
    kpdReasons: CompatiblePairKpdReasons[];
    kpdOtherReason: string;
    declineRatio: number;
}
